import React, { useRef } from 'react'
import emailjs from 'emailjs-com';
import { Button,Form } from 'react-bootstrap'
import './Getintouch.css'


function Getintouch() {

    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_t6bsy0v', 'template_c9i3hg6',
        e.target, 'xb8mKmRlvsIzr91Q-')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
      e.target.reset()
    };
    
  

  return (
    <div className='email'>
        <h1>Get In Touch</h1>
        <div className="emailform">
                <h2>Lets Chat through Mail</h2>
                <Form ref={form} onSubmit={sendEmail} className="formmail">
                  <label>Email:</label>
                  <input
                    placeholder='Email...'
                
                    type='email'
                    name='email'
                    required
                  />
                  <label>Name:</label>
                  <input
                    placeholder='Name...'
                    type='name'
                    name='name'
                    required
                  />
                  <label>Subject:</label>
                  <input
                    placeholder='Subject...'
                    type='text'
                    name='subject'
                    required
                  />
                  <label>Message:</label>
                  <textarea
                    name='message'
                    placeholder='message...'
                    required></textarea>
                  <Button type='submit' color='green'>Submit</Button>                
                
              </Form>
              
              </div>
              <div className='f'></div>
    </div>
  )
}

export default Getintouch